import TopNavigation from '@/widgets/TopNavigation.vue'
import { fetchRoutes, fetchTerminals } from './functions'
import cachedSettings from '@/utils/cached-settings'
import { mapSort, sortStrings, sortNumbers, reverseSorter } from '@/utils/sorting'
import Distribution from '@/dashboards/Distribution.vue'
import Merchant from '@/dashboards/Merchant.vue'

const sortTerminals = mapSort(sortStrings, ({ label }) => label)
const sortRoutes = reverseSorter(mapSort(sortNumbers, (route) => route.severity.weight))

export default {
    name: 'Dashboard',
    data: () => ({
        terminals: [],
        countries: [],
        routes: [],
        selectedTerminals: [],
        dashboards: [
            { id: 'DISTRIBUTION', label: 'Distribution' },
            { id: 'MERCHANT', label: 'Merchant' },
        ],
        selectedDashboard: cachedSettings.getDashboard() || 'DISTRIBUTION',
    }),
    components: {
        TopNavigation,
        Distribution,
        Merchant,
    },
    methods: {
        setDashboard(dashboard) {
            this.selectedDashboard = dashboard
            cachedSettings.saveDashboard(dashboard)
        },
        setSelectedTerminals(terminalsNowSelected) {
            this.selectedTerminals = terminalsNowSelected
            const selectedTerminalIds = terminalsNowSelected.map((terminal) => terminal.id)
            cachedSettings.saveTerminalIds(selectedTerminalIds)
        },
        openRoute(url) {
            if (this.windowRef == null || this.windowRef.closed) {
                this.windowRef = window.open(url, 'RouteOverview', '_blank')
            } else {
                const {
                    location: { protocol, host },
                } = window
                this.windowRef.postMessage(url, `${protocol}//${host}`)
            }
        },
    },
    beforeMount() {
        fetchTerminals().then((res) => {
            this.terminals = res.terminals.sort(sortTerminals)
            this.countries = res.countries.sort(sortTerminals)
            const cachedSelectedTerminals = cachedSettings.getTerminalIds()
            this.selectedTerminals = this.terminals.filter((terminal) =>
                cachedSelectedTerminals.includes(terminal.id),
            )
        })

        const fr = () =>
            fetchRoutes()
                .then((routes) => {
                    this.routes = routes.sort(sortRoutes)
                })
                .catch((err) => console.error(err))
                .finally(() => setTimeout(fr, 20000))

        fr()
    },
}
